import { render, staticRenderFns } from "./LandsideCallToAction.vue?vue&type=template&id=a22ac9a0&"
import script from "./LandsideCallToAction.vue?vue&type=script&setup=true&lang=ts&"
export * from "./LandsideCallToAction.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports